export default "__VITE_ASSET__BZIO03ry__"